<template>
  <!-- 海报分享指引 -->
  <div v-if="display" class="Dialog share">
    <div class="inner">
      <!-- 保存提示 -->
      <div class="share-prompt">长按或截屏保存图片，分享给好友领礼包</div>
      <!-- 关闭 -->
      <i class="close" @click="hide"></i>

      <!-- 分享弹窗 -->
      <div id="shareFissionContainer" class="share">
        <img class="share-bg" crossOrigin="anonymous" :src="postInfo.backgroundImage" alt="" />
        <div class="jcc-code">
          <img id="sharecodefission" src="" alt="" />
        </div>
      </div>
      <!-- 分享盒子 -->
      <img v-if="shareImg" class="share-box" :src="shareImg" alt="" />
    </div>
  </div>
</template>
<script>
import { generateQRCode, generateScreenShots } from "@api/share"
import { reactive, toRefs, onMounted } from "@vue/composition-api"
import { addGetParam } from "@tencent/midas-util"
import { PAGE_VIEW } from "../../../constants/report-dictonary"

export default {
  props: ["postInfo", "fissionId", "groupId", "root"],

  setup(props) {
    const state = reactive({
      shareImg: "",
      display: false
    })

    let { root, postInfo, groupId, fissionId } = props

    const hide = () => {
      state.display = false
    }

    const show = () => {
      state.display = true
    }

    onMounted(() => {
      root.setToastMsg("海报制作中请稍等")

      setTimeout(() => {
        root.$nextTick(() => {
          renderShare()
        })
      }, 800)

      root.reportUserAction({
        iformat: PAGE_VIEW.DETAIL_FISSION_POSTER
      })
    })

    // 获取裂变的url
    const getShareUrl = () => {
      return addGetParam(
        {
          pf: `${props.root.pf}.detailposter`,
          sandbox: props.root.sandbox
        },
        `${postInfo.fissionShareLink}&groupId=${groupId}&fissionId=${fissionId}`
      )
    }

    // 渲染海报内容
    const renderShare = () => {
      generateQRCode({
        url: getShareUrl(),
        success: url => {
          document.getElementById("sharecodefission").src = url

          // 如果分享窗口已经关闭，则不再绘制分享页面
          if (!document.getElementById("shareFissionContainer")) return

          generateScreenShots("shareFissionContainer")
            .then(base64Img => {
              state.shareImg = base64Img
            })
            .catch(() => {
              // 如果分享窗口已经关闭，则忽略报错
              if (!document.getElementById("shareFissionContainer")) return

              root.setToastMsg("系统繁忙，请重试")
            })
        },
        fail: () => {
          root.setToastMsg("系统繁忙，请重试")
        }
      })
    }

    return {
      ...toRefs(state),
      hide,
      show
    }
  }
}
</script>
